import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { BaseRevisioneFormService } from '../../../abstracts/base-revisione-form.service';
import { manageSchedaDisabled } from '../common/helper/scheda-settore.helper';
import { revisione53DatiFormSelectors } from '../../../store/selectors/dati-form.selectors';

@Injectable({
    providedIn: 'root',
})
export class SchedaCoopProdLavoroFormService extends BaseRevisioneFormService {
    isDisabled$: Observable<boolean>;

    constructor() {
        super();
    }

    protected override initForm(): FormGroup {
        return this.fb.group({});
    }

    protected override afterFormInitialize(): void {
        this._manageDeactivation();
    }

    private _manageDeactivation(): void {
        this.isDisabled$ = manageSchedaDisabled(this.store, revisione53DatiFormSelectors.getScPDLObbl);
    }
}
